<template>
  <s-layout
    :title="curTitle"
    :defaultBtns="defaultBtns"
    @command="handleCommand"
  >
    <el-scrollbar>
      <s-form
        ref="formRef"
        :formList="formList"
        :api="api"
        :beforeSave="beforeSave"
        :afterGet="afterGet"
        :detailParam="detailParam"
        :rules="rules"
        @change="handleChange"
      >
        <!-- @slot el-form后插槽名  -->
        <slot></slot>
        <template #[item]="{ form }" v-for="item in slots" :key="item">
          <!-- @slot el-form-item内的插槽名  -->
          <slot :name="item" :form="form" />
        </template>
      </s-form>
    </el-scrollbar>
  </s-layout>
</template>
<script>
import {
  getCurrentInstance,
  defineComponent,
  ref,
  provide,
  reactive,
  onMounted,
  watch,
  toRefs,
  computed,
} from "vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import formMixin from "./formMixin";

export default defineComponent({
  name: "sDetail",
  components: {},
  mixins: [formMixin],
  props: {
    title: {
      type: String,
      default: "",
      required: true,
    },
    /** 必须和formList中插槽同名*/
    slots: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const formRef = ref();
    const state = reactive({
      defaultBtns: {
        save: route.query.type !== "detail",
        back: true,
      },
    });
    const curTitle = computed(() => {
      if (route.query.type === "edit") {
        return "编辑" + props.title;
      } else if (route.query.type === "add") {
        return "新增" + props.title;
      } else if (route.query.type === "detail") {
        return props.title + "详情";
      }
      return "";
    });
    onMounted(() => {});
    //按钮操作
    const handleCommand = (command) => {
      switch (command) {
        case "save":
          handleSave();
          break;
        default:
          break;
      }
    };
    //点击保存
    const handleSave = () => {
      console.log(formRef.value.form, "====2");
      formRef.value.ruleFormRef.validate(async (valid, fields) => {
        if (valid) {
          //表单验证通过
          if (props.beforeSave) {
            //提交之前对表单数据进行处理
            const form = await props.beforeSave(formRef.value.form);
            if (!form) {
              return;
            }
            if (props.api.add && route.query.type === "add") {
              proxy.$api[props.api.add](form, "post").then((res) => {
                proxy.$message.success("操作成功");
                goBack();
              });
            } else if (props.api.edit && route.query.type === "edit") {
              proxy.$api[props.api.edit](form, "put").then((res) => {
                proxy.$message.success("操作成功");
                goBack();
              });
            }
          } else {
            if (props.api.add && route.query.type === "add") {
              proxy.$api[props.api.add](formRef.value.form, "post").then(
                (res) => {
                  proxy.$message.success("操作成功");
                  goBack();
                }
              );
            } else if (props.api.edit && route.query.type === "edit") {
              proxy.$api[props.api.edit](formRef.value.form, "put").then(
                (res) => {
                  proxy.$message.success("操作成功");
                  goBack();
                }
              );
            }
          }
        }
      });
    };
    /*返回*/
    const goBack = () => {
      router.go(-1);
    };
    //请求数据成功后
    const handleChange = (form) => {
      emit("change", form);
    };
    return {
      formRef,
      curTitle,
      ...toRefs(state),
      handleCommand,
      goBack,
      handleChange,
    };
  },
});
</script>
<style scoped lang="less"></style>
<docs lang="md">
### props

###### formList.slot

- 用户自定义插入 el-form-item 的插槽名

###### formList.form item

- @param {string} label - 必传,标签文本
- @param {string} value - 必传,组件 model 的键名
- @param {string} component - 默认为 el-input
- @param {string} slot - el-form-item 内的插槽名
- @param {function} showCondition - 控制 el-form-item,参数为 form
- @param {function} getParams -给 params 传参
- @param element 组件的其他参数
</docs>
